<script setup lang="ts">
import type { DropdownMenuItemProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from "@vueuse/core"
import { DropdownMenuItem, useForwardProps } from 'reka-ui';
import { cn } from '@/utils/shadcn';

const props = withDefaults(defineProps<DropdownMenuItemProps & {
  class?: HTMLAttributes['class'];
  inset?: boolean;
  variant?: 'default' | 'destructive';
}>(), {
  variant: 'default',
});

const delegatedProps = reactiveOmit(props, 'inset', 'variant', 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <DropdownMenuItem
    data-slot="dropdown-menu-item"
    :data-inset="inset ? '' : undefined"
    :data-variant="variant"
    v-bind="forwardedProps"
    :class="cn(
      'relative flex items-center rounded-[8px] px-3 py-2 text-sm text-text-primary outline-none cursor-default select-none transition-colors duration-150',
      'data-[highlighted]:bg-(--color-primary-subtle) data-[highlighted]:text-(--color-primary)',
      'data-[variant=destructive]:text-(--color-destructive) data-[variant=destructive]:data-[highlighted]:bg-red-50',
      'data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
      'data-[inset]:pl-8',
      props.class,
    )"
  >
    <slot></slot>
  </DropdownMenuItem>
</template>
